export default __webpack_public_path__ + "static/media/arrow_down_white.7575eb68.svg";